export enum Portal {
  MAZDA = 'mppdealerportalcom',
}
